// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__OFyqy","versionTag":"style_versionTag__CX1mZ","menu":"style_menu__GUN3X"};